import { ReactNode, CSSProperties } from 'react';
import { S3_BASE_URL } from '../SignalsTemplate/SignalsTemplateComponents';

export const TR = ({ children, className }: { children: ReactNode, className?: string }) => {
    return <tr style={{ backgroundColor: 'white' }} className={className}>{children}</tr>;
};

type Align = 'left' | 'center' | 'right' | 'justify' | 'char';

type VAlign = 'top' | 'middle' | 'bottom' | 'baseline';

export const TD = ({
    children,
    align,
    valign,
    style = {},
    width,
}: {
    children: ReactNode;
    align?: Align;
    valign?: VAlign;
    style?: CSSProperties;
    width?: number;
}) => {
    return (
        <td
            align={align}
            valign={valign}
            style={{ height: 24, padding: 0, ...style }}
            //@ts-ignore
            width={width}>
            {children}
        </td>
    );
};

export const TBody = ({
    children,
    style = {},
}: {
    children: ReactNode;
    style?: CSSProperties;
}) => {
    return (
        <tbody style={{ border: 'none', backgroundColor: 'white', ...style }}>
            {children}
        </tbody>
    );
};

export const Separator = () => {
    return (
        <td style={{ padding: 0, maxWidth: 600 }}>
            <img
                alt="separator"
                style={{ maxWidth: '100%' }}
                src={`${S3_BASE_URL}/red-gradient-seperator.png`}
            />
        </td>
    );
};

export const InsightsLogo = () => (
    <TD align="center" style={{ maxWidth: 600 }}>
        <img
            alt="logo"
            src={`${S3_BASE_URL}/Logo_BMI_Geo_Risk_Signals_Colour_nonend.png`}
            style={{
                maxWidth: '50%',
                maxHeight: 70,
            }}
        />
    </TD>
);
